<template>
  <modal
    ref="ticketDataModal"
    template="neutral"
    ref-name="ticketDataModal"
    class="ticket-modal"
    :close-button-enabled="true"
  >
    <div
      class="ticket-modal__wrapper"
      :class="{ 'ticket-modal__wrapper--loading': loading }"
    >
      <spinner
        v-if="loading"
        class="loading"
      />
      <template v-else>
        <div v-if="ticketData">
          <h2>Dados do Boleto:</h2>
          <div class="ticket-modal__content">
            <ul>
              <li>
                <strong>CNPJ do Pagador:</strong>
                {{ ticketData.withdrawnCNPJ }}
                <ButtonCopy
                  v-if="ticketData.withdrawnCNPJ"
                  :text-to-copy="ticketData.withdrawnCNPJ"
                />
              </li>
              <li>
                <strong>CNPJ do Beneficiário:</strong>
                {{ ticketData.assignorCNPJ }}
                <ButtonCopy
                  v-if="ticketData.assignorCNPJ"
                  :text-to-copy="ticketData.assignorCNPJ"
                />
              </li>
              <li>
                <strong>Número Boleto:</strong>
                {{ ticketData.ticketNumberNotVerifyDigit }}
                <ButtonCopy
                  v-if="ticketData.ticketNumberNotVerifyDigit"
                  :text-to-copy="ticketData.ticketNumberNotVerifyDigit"
                />
              </li>
            </ul>
          </div>
          <div class="ticket-modal__actions">
            <button
              class="btn btn-primary btn-new"
              @click="goToTicketURL"
            >
              Ir para segunda via do boleto
            </button>
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
import billings from '@/api/billings'
import Spinner from '@/components/common/Spinner'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import notify from '@/api/notification'

export default {
  name: 'TicketDataModal',
  components: {
    Spinner,
    ButtonCopy,
  },
  data() {
    return {
      loading: false,
      ticketData: null,
    }
  },
  methods: {
    openTicketDataModal(ticketNumber, walletType) {
      this.$refs.ticketDataModal.open()
      this.getTicketData(ticketNumber, walletType)
    },
    goToTicketURL() {
      if (!this.ticketData) return
      const pagador = this.ticketData.withdrawnCNPJ.replace(/\D/g, '')
      const beneficiario = this.ticketData.assignorCNPJ.replace(/\D/g, '')
      const boleto = this.ticketData.ticketNumberNotVerifyDigit
      const baseUrl = this.ticketData.bankAddress.endsWith('/') ? this.ticketData.bankAddress.slice(0, -1) : this.ticketData.bankAddress

      window.open(
        `${baseUrl}/${boleto}/${pagador}/${beneficiario}/1`,
        '_blank',
        'width=600, height=500'
      )
    },
    getTicketData(ticketNumber, walletType) {
      this.loading = true

      billings
        .getTicketData(ticketNumber, walletType)
        .then(res => {
          this.loading = false
          this.ticketData = res.data
        })
        .catch(err => {
          this.loading = false
          this.ticketData = null
          this.$refs.ticketDataModal.close()
          notify({
            title: 'AVISO: ',
            message: 'Erro ao carregar os dados do boleto.',
          })
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss">
.ticket-modal {
  .md-dialog {
    width: 90%;
    min-height: 275px !important;
    padding: 30px 50px;
    max-height: 84% !important;

    &-content,
    &-title {
      padding: 0;

      .close-button {
        z-index: 2;
      }
    }

    .standard-modal__title {
      display: none;
    }
  }

  &__wrapper {
    font-family: 'Exo 2', sans-serif !important;
    min-height: 240px;

    &--loading {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__content {
    padding: 20px 24px;
    background: rgba(22, 22, 22, 0.04);
    border-radius: 6px;
    margin-top: 18px;
    font-weight: 400;
    font-size: 14px;
    font-family: 'Exo 2', sans-serif !important;

    span {
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
    }

    ul {
      li {
        display: flex;
        align-items: center;

        &:hover {
          .btn-copy {
            opacity: 1;
          }
        }

        strong {
          margin-right: 8px;
        }

        .btn-copy {
          margin-left: 14px;

          span {
            color: #fff;
          }
        }
      }
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    .btn {
      width: 100%;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
    }
  }
}
</style>
